import dayjs from "lib/dayjs";

export function getPortfolioPeriodOpeningDate(startDate) {
  if (!startDate) return "";
  const date = dayjs(startDate);
  return date.isValid() ? date.subtract(1, "day").format("YYYY-MM-DD") : "";
}

export function getPortfolioComparisonPeriod(startDate, endDate) {
  const start = dayjs(startDate);
  const end = dayjs(endDate);
  if (!start.isValid() || !end.isValid() || end.isBefore(start, "day")) return null;

  const isFullYear =
    start.month() === 0 &&
    start.date() === 1 &&
    end.month() === 11 &&
    end.date() === 31 &&
    start.year() === end.year();
  const isFullQuarter =
    start.date() === 1 &&
    start.month() % 3 === 0 &&
    end.isSame(start.add(2, "month").endOf("month"), "day");
  const isFullMonth =
    start.date() === 1 && end.isSame(start.endOf("month"), "day");

  let comparisonStart;
  let comparisonEnd;
  if (isFullYear) {
    comparisonStart = start.subtract(1, "year");
    comparisonEnd = end.subtract(1, "year");
  } else if (isFullQuarter) {
    comparisonStart = start.subtract(3, "month");
    comparisonEnd = start.subtract(1, "day");
  } else if (isFullMonth) {
    comparisonStart = start.subtract(1, "month");
    comparisonEnd = start.subtract(1, "day");
  } else {
    const inclusiveDays = end.diff(start, "day") + 1;
    comparisonEnd = start.subtract(1, "day");
    comparisonStart = comparisonEnd.subtract(inclusiveDays - 1, "day");
  }

  return {
    startDate: comparisonStart.format("YYYY-MM-DD"),
    endDate: comparisonEnd.format("YYYY-MM-DD"),
  };
}

